import React from 'react';
import type { CSSProperties, MouseEventHandler } from 'react';
import { Button } from 'src/design-system/components/atoms/Button/Button';
import classnames from 'classnames';

interface IProps {
    onClick?: MouseEventHandler<HTMLElement>;
    children: React.ReactNode;
    className?: string;
    style?: CSSProperties;
    disabled?: boolean;
    loading?: boolean;
}

const GenericActionButton = React.forwardRef((props: IProps, ref: any) => {
    const { children, onClick, style, className, disabled, loading, danger = false } = props;
    return (
        <Button
            className={classnames(className)}
            type="secondary"
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            style={style}
            ref={ref}
            danger={danger}
        >
            {children}
        </Button>
    );
});

GenericActionButton.defaultProps = {
    onClick: (e) => {},
    style: {},
    className: '',
    disabled: false,
    loading: false,
};

export default GenericActionButton;
